import { IChangeDataGrid } from "../../components/grids/changeableGrid/ChangeableGrid";

type SetState<T> = React.Dispatch<React.SetStateAction<T>>;

export const fillDisplayItemWithCellValue = <T extends Record<string, any>>(
    cell: IChangeDataGrid,
    allowedFields: readonly (keyof T)[],
    setItems: SetState<T[]>,
    getId: (item: T) => string | number = (item) => (item as any).idGlobal // дефолтный геттер
) => {
    const { idGlobal, propertyName, value } = cell;

    const key = propertyName as keyof T;

    // Проверка: разрешено ли поле
    if (!allowedFields.includes(key)) {
        console.warn(`Обработчик значения не задан: ${propertyName}`);
        return;
    }

    // Автоматическое приведение значения к типу поля T[key]
    const coerceValue = <K extends keyof T>(k: K, val: string | number | boolean): T[K] => {
        const dummyObj = {} as T;
        const expectedType = typeof dummyObj[k];

        if (typeof val === expectedType) {
            return val as T[K];
        }

        if (expectedType === 'number') {
            const n = typeof val === 'string' ? parseFloat(val) : Number(val);
            return (isNaN(n) ? 0 : n) as T[K];
        }

        if (expectedType === 'boolean') {
            return Boolean(val) as T[K];
        }

        if (expectedType === 'string') {
            return String(val) as T[K];
        }

        return val as T[K];
    };

    // Обновляем массив
    setItems((prev) =>
        prev.map((item) =>
            getId(item) === idGlobal
                ? {
                    ...item,
                    [key]: coerceValue(key, value),
                }
                : item
        )
    );
};
